import WorkOrderOperation from './WorkOrderOperation'

export default WorkOrderOperation;